import { useIntl } from "react-intl";
import { useFormContext, useWatch } from "react-hook-form";

import Dropdown from "components/atoms/Dropdown/Dropdown";
import { appendDefaultOption } from "helpers/commonHelpers";
import {
  dangerousGoodsOptions,
  temperatureControlledOptions,
} from "pages/shipper/RequestForm/components/PackingList/PackingListDefaultOptions";
import CheckboxWithLabel from "pages/shipper/RequestForm/components/PackingList/components/CheckboxWithLabel";
import InputField from "components/atoms/InputField/InputField";

function PropertyFields({ selectedHandlingUnitConfig }: { selectedHandlingUnitConfig: any }) {
  const intl = useIntl();
  const { control, getValues } = useFormContext();
  const [isDangerousGood, isTemperatureControlRequired, temperatureControlValue] = useWatch({
    name: ["is_dangerous_good", "temperature_control_required", "temperature_control_value"],
    control,
  });

  return (
    <div className="flex-row flex-wrap mt-4">
      {/* Stackable checkbox */}
      <CheckboxWithLabel
        label={intl.formatMessage({
          id: "new-request.packing-list.stackable",
          defaultMessage: "Stackable",
        })}
        name="stackable"
        showCheckbox={selectedHandlingUnitConfig?.stackable}
      />
      {/* Crating required checkbox */}
      <div className="d-flex flex-column">
        <CheckboxWithLabel
          label={intl.formatMessage({
            id: "new-request.packing-list.cratingRequired",
            defaultMessage: "Crating required",
          })}
          name="crating_required"
          showCheckbox
        />
      </div>
      {/* Temperature controlled checkbox */}
      <div className="d-flex flex-column">
        <CheckboxWithLabel
          label={intl.formatMessage({
            id: "new-request.packing-list.temperatureControlled",
            defaultMessage: "Temperature controlled",
          })}
          name="temperature_control_required"
          showCheckbox
        />
        {isTemperatureControlRequired && (
          <Dropdown
            useHookForm
            required={getValues(`temperature_control_required`)}
            name="temperature_control_value"
            options={appendDefaultOption(temperatureControlledOptions(intl), intl)}
            defaultValue=""
            shouldUnregister
          />
        )}
        {temperatureControlValue === "6" && (
          <div className="mt-2">
            <InputField
              placeholder={intl.formatMessage({
                id: "new-request.packing-list.pleaseProvide",
                defaultMessage: "Please provide",
              })}
              field_id="temperature_controlled_custom_value"
              required
            />
          </div>
        )}
      </div>
      {/* Dangerous goods checkbox */}
      <div className="d-flex flex-column">
        <CheckboxWithLabel
          label={intl.formatMessage({
            id: "new-request.packing-list.dangerousGoods",
            defaultMessage: "Dangerous goods",
          })}
          name="is_dangerous_good"
          showCheckbox
        />
        {isDangerousGood && (
          <Dropdown
            useHookForm
            name="dangerous_good_value"
            options={appendDefaultOption(dangerousGoodsOptions(intl), intl)}
            defaultValue=""
            required={isDangerousGood}
          />
        )}
      </div>
      {/* Handling required checkbox */}
      <div className="d-flex flex-column">
        <CheckboxWithLabel
          label={intl.formatMessage({
            id: "new-request.packing-list.handlingRequired",
            defaultMessage: "Handling required",
          })}
          name="handling_required"
          showCheckbox={selectedHandlingUnitConfig?.handling_required}
        />
      </div>
    </div>
  );
}

export default PropertyFields;
